// Announcement form field constants
export const TITLE = 'Title';
export const DESCRIPTION = 'Description';
export const EXPIRE_DATE = 'ExpireDate';
export const MORE_LINK = 'MoreLink';

// Action types
export const RESET = 'RESET';
export const ANNOUNCEMENT_CONVERT = 'ANNOUNCEMENT_CONVERT';
